import { BaseStyles, FontStyles } from "../CurrencySEOCommonUI";
import CurrencyDocument from "./CurrencyDocument";
import { CurrencyRatePageStyle } from "./CurrencyRatePageTemplate.styles";
import Header from "./Header";
import Hero from "./Hero";
import Introduction from "./Introduction";
import BestRate from "./BestRate";
import WhyToBuy from "./WhyToBuy";
import HowToBuy from "./HowToBuy";
import HowBestPrice from "./HowBestPrice";
import OtherServices from "./OtherServices";
import CurrencyInformation from "./CurrencyInformation";
import CurrencyExchangeInformation from "./CurrencyExchangeInformation";
import TopReviewedCurrencies from "./TopReviewedCurrencies";
import OtherConversions from "./OtherConversions";
import Faqs from "./Faqs";
// import { CurrencyFooter } from "./CurrencyFooter";
import Banner from "./Banner";
import ForexProduct from "../CurrencyConverterPageTemplate/ForexProducts";
import { CurrencyFooter } from "../CurrencyPageTemplate/CurrencyFooter";
import { useEffect } from "react";
import { PAGE_NAMES, trackSeoPageLoad } from "@tm/utility/analytics";
import PopularDenomitations from "./PopularDenominations";
import CurrencyExchangeInCity from "./CurrencyExchangeInCity";
import { SEO_TEMPLATE_TYPE, DEVICE_SIZES } from "@tm/static/utils";
import { ListingUiWrapper } from "@forex/listing-ui";
import BreadCrumb from "@forex/Forex/Breadcrumb";
import { useBotDetection } from "../../hooks";

// Wrapper component to handle deviceType logic
const SectionWrapper = ({
  children,
  deviceType,
}: {
  children: React.ReactNode;
  deviceType: string | null;
}) => {
  if (deviceType === DEVICE_SIZES.LARGE) {
    return <div className="sectionWrapper">{children}</div>;
  }
  return <>{children}</>;
};

export const CurrencyRatePageTemplate = ({
  id,
  currencyData,
  inrExchangeRate,
  currCodeToCurrRate,
  switchInrExchnageRate,
  canonicalHref,
  deviceType,
}: any) => {
  const isBot = useBotDetection();

  useEffect(() => {
    trackSeoPageLoad({
      pageName: PAGE_NAMES["SEO_CURRENCY_RATE"]?.replace(
        "NAME",
        `${currencyData?.curr_code}`
      ),
      currency: currencyData?.curr_code,
    });
  }, []);

  const heading1 = currencyData?.hero?.title?.split("Currency Converter")[0];

  return (
    <>
      <FontStyles />
      <BaseStyles />
      <CurrencyRatePageStyle deviceType={deviceType} />
      <CurrencyDocument
        currencyData={currencyData}
        canonicalHref={canonicalHref}
      />
      <>
        <Header currencyData={currencyData} />
        {deviceType === DEVICE_SIZES.SMALL && (
          <Hero
            currencyData={currencyData}
            inrExchangeRate={inrExchangeRate}
            currCodeToCurrRate={currCodeToCurrRate}
            switchInrExchnageRate={switchInrExchnageRate}
            breadcrumb={currencyData?.breadcrumb}
          />
        )}
        {deviceType === DEVICE_SIZES.LARGE && (
          <div id="top-banner">
            <div className="top-banner__container">
              <h1 className="top-banner__title">{heading1}</h1>
              <div className="top-banner__breadcrumb">
                <BreadCrumb breadCrumbData={currencyData?.breadcrumb || []} />
              </div>
            </div>
            <div className="top-banner__wrapper">
              <ListingUiWrapper
                source_type="seo"
                isBot={isBot}
                deviceType={deviceType}
                page_name="currency_rate"
              />
            </div>
          </div>
        )}

        <div
          className={`pageContainerWrapper ${
            deviceType === DEVICE_SIZES.LARGE
              ? "pageContainerWrapper--large"
              : "pageContainerWrapper--small"
          }`}
        >
          <div className="pageContainer">
            {deviceType === DEVICE_SIZES.SMALL && (
              <ForexProduct
                currencyData={currencyData}
                pageName={PAGE_NAMES["SEO_CURRENCY_RATE"]?.replace(
                  "NAME",
                  `${currencyData?.curr_code}`
                )}
                templateType={SEO_TEMPLATE_TYPE.CURRENCY_RATE}
              />
            )}
            <div className="pageContent">
              <Banner currencyData={currencyData} />

              {currencyData?.introduction?.para && (
                <SectionWrapper deviceType={deviceType}>
                  <Introduction currencyData={currencyData} />
                </SectionWrapper>
              )}

              <SectionWrapper deviceType={deviceType}>
                <BestRate currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <WhyToBuy currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <HowToBuy currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <HowBestPrice currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <OtherServices currencyData={currencyData} />
              </SectionWrapper>

              {currencyData?.popular_denominations?.title && (
                <SectionWrapper deviceType={deviceType}>
                  <PopularDenomitations
                    currencyData={currencyData}
                    inrExchageRate={inrExchangeRate}
                  />
                </SectionWrapper>
              )}

              <SectionWrapper deviceType={deviceType}>
                <CurrencyInformation currencyData={currencyData} />
              </SectionWrapper>

              {currencyData?.other_conversions?.title &&
                currencyData?.other_conversions?.cards && (
                  <SectionWrapper deviceType={deviceType}>
                    <OtherConversions currencyData={currencyData} />
                  </SectionWrapper>
                )}

              <SectionWrapper deviceType={deviceType}>
                <Faqs currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <TopReviewedCurrencies currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <CurrencyExchangeInformation currencyData={currencyData} />
              </SectionWrapper>

              <SectionWrapper deviceType={deviceType}>
                <CurrencyExchangeInCity currencyData={currencyData} />
              </SectionWrapper>
            </div>
          </div>
        </div>

        {currencyData?.footer ? (
          <CurrencyFooter footer={currencyData?.footer} hideTopLinks />
        ) : null}

        {/* <CurrencyFooter footer={currencyData?.footer} /> */}
      </>
    </>
  );
};
